/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/**
 * A callback registered through {@link PromiseAbortController.addRejectCallback}.
 *
 * It is called without an argument when it is registered after the controller has
 * already aborted, and with the abort reason when {@link PromiseAbortController.abort}
 * runs, so the reason is optional.
 */
export type PromiseRejectCallback = (reason?: unknown) => void;

export default class PromiseAbortController {
	rejects: PromiseRejectCallback[] = [];
	isAborted: boolean = false;

	addRejectCallback(reject: PromiseRejectCallback): void {
		if (this.isAborted) {
			reject();
		}
		this.rejects.push(reject);
	}

	abort(): void {
		this.isAborted = true;
		this.rejects.forEach((reject) => {
			try {
				reject('cancel login');
			} catch (error) {
				console.error(error);
			}
		});
	}
}
